import { TTableEntity } from 'types/tableEntityType';

export const areAllEntitiesSelected = (
  selectedEntities: TTableEntity[],
  providedEntities: TTableEntity[]
): boolean => {
  return providedEntities.every((entity) =>
    selectedEntities.some((selected) => selected.spaceId === entity.spaceId)
  );
};
